import { Injectable } from "@angular/core";
import { ActionSheetController } from "@ionic/angular";
import { ActionSheetButton } from "@ionic/core/dist/types/components/action-sheet/action-sheet-interface";

@Injectable({
  providedIn: "root",
})
export class ActionSheetService {
  constructor(private readonly actionSheetController: ActionSheetController) {}

  public async showActionSheet(header: string, buttons: ActionSheetButton[]): Promise<void> {
    const actionSheet = await this.actionSheetController.create({
      header,
      buttons: [
        ...buttons,
        {
          text: "Cancel",
          role: "cancel",
          data: {
            action: "cancel",
          },
        },
      ],
    });

    await actionSheet.present();
  }
}
